import {
  RIDER_SALE_STATUSES,
  SALE_PAYMENT_METHODS,
} from "@artisancode/api-types";
import { z } from "zod";

import { todayIso } from "./rider-sale-utils";

export const riderSaleLineSchema = z
  .object({
    productId: z.string(),
    dispatchedQty: z.number().int().min(0),
    soldQty: z.number().int().min(0),
    returnedQty: z.number().int().min(0),
  })
  .refine(
    (line) => line.soldQty + (line.returnedQty ?? 0) <= line.dispatchedQty,
    {
      message: "Total Jual + Kembali tidak boleh lebih besar dari Ambil",
      path: ["soldQty"],
    },
  );

export const riderSalePaymentSchema = z.object({
  method: z.enum(SALE_PAYMENT_METHODS),
  amount: z.number().min(0),
});

export const riderSaleSchema = z.object({
  date: z.string().min(1, "Tanggal wajib diisi"),
  riderId: z.string().min(1, "Rider wajib dipilih"),
  transactionCode: z.string().optional(),
  lines: z.array(riderSaleLineSchema),
  payments: z.array(riderSalePaymentSchema),
  status: z.enum(RIDER_SALE_STATUSES),
  notes: z.string().optional(),
});

export type RiderSaleFormValues = z.infer<typeof riderSaleSchema>;
export type RiderSaleLineFormValues = z.infer<typeof riderSaleLineSchema>;
export type RiderSalePaymentFormValues = z.infer<typeof riderSalePaymentSchema>;

export const defaultRiderSaleValues: RiderSaleFormValues = {
  date: todayIso(),
  riderId: "",
  transactionCode: "",
  lines: [],
  payments: [],
  status: "draft",
  notes: "",
};
